<template>
  <!-- 패널이 열렸을 때만 표시, 동그란 버튼 제거 -->
  <div v-if="props.isOpen" class="script-panel">
    <div class="script-header">
      <h3>대화 내용</h3>
      <div class="script-controls">
        <button @click="closePanel" class="btn-close">
          <!-- <i class="fas fa-times"></i> -->
        </button>
      </div>
    </div>
    <div class="script-content">
      <div class="script-messages" ref="messagesContainer">
        <div 
          v-for="(message, index) in props.scriptHistory" 
          :key="index" 
          class="script-message"
        >
          <div class="message-bubble">
            <span class="speaker-name">{{ message.speaker }}</span>
            <span class="message-text">{{ message.text }}</span>
          </div>
        </div>
        <div v-if="props.scriptHistory.length === 0" class="no-messages">
          대화가 시작되면 여기에 표시됩니다.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, watch, ref } from 'vue'

const props = defineProps({
  scriptHistory: {
    type: Array,
    default: () => []
  },
  isOpen: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close'])

const messagesContainer = ref(null)

function closePanel() {
  emit('close')
}

// 새 메시지가 추가되면 자동으로 스크롤 하단으로 이동
watch(() => props.scriptHistory.length, () => {
  nextTick(() => {
    if (messagesContainer.value) {
      messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight;
    }
  })
})

// 패널이 열릴 때 스크롤 하단으로 이동
watch(
  () => props.isOpen,
  (newVal) => {
    if (newVal) {
      nextTick(() => {
        if (messagesContainer.value) {
          messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight;
        }
      });
    }
  }
);
</script>

<style scoped>
.script-panel {
  position: fixed;
  bottom: 90px; 
  right: 20px;
  width: 380px;
  height: calc(100vh - 40px);
  max-height: 500px;
  background: rgba(255, 255, 255, 0.98);
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.script-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  border-radius: 16px 16px 0 0;
  flex-shrink: 0;
}

.script-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.script-controls {
  display: flex;
  align-items: center;
}

.btn-close {
  background: none;
  border: none;
  font-size: 18px;
  color: white;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-close:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1); /* 호버 시 확대 효과 추가 */
}

.script-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.script-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.script-message {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.message-bubble {
  background: linear-gradient(135deg, #f8fafc, #e2e8f0);
  border-radius: 18px 18px 18px 4px;
  padding: 12px 16px;
  max-width: 85%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.speaker-name {
  font-weight: 700;
  color: #6366f1;
  font-size: 12px;
  display: block;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.message-text {
  color: #374151;
  line-height: 1.5;
  font-size: 14px;
  word-wrap: break-word;
}

.no-messages {
  text-align: center;
  color: #9ca3af;
  font-style: italic;
  padding: 40px 20px;
  font-size: 14px;
}

/* 스크롤바 스타일링 */
.script-messages::-webkit-scrollbar {
  width: 6px;
}

.script-messages::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}

.script-messages::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  border-radius: 3px;
}

.script-messages::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
}
</style>
